import { Message } from '@rossum/api-client/shared';
import {
  IconAlertOctagon,
  IconInfoSquareRounded,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';

const icons = {
  error: IconAlertOctagon,
  warning: IconAlertOctagon,
  info: IconInfoSquareRounded,
};

type Props = {
  type: Message['type'];
  active?: boolean;
  isSimpleMultivalue?: boolean;
};

const Icon = ({ type, active, isSimpleMultivalue }: Props) => {
  const RenderedIcon = icons[type];

  return (
    <SvgIcon
      fontSize="medium"
      color={active && !isSimpleMultivalue ? 'inherit' : type}
      data-cy={type === 'error' ? 'error-icon' : ''}
    >
      <RenderedIcon />
    </SvgIcon>
  );
};

export default Icon;
